export const routesArray = [
  "/",
  "/feis/manage",
  "/grade/manage",
  "/event-details",
  "/users",
  "/schools",
  "/feis",
  "/grade",
  "/oireachtas",
  "/oireachtas/manage",
  "/oireachtas/status",
  "/oireachtas/competitors",
  "/oireachtas/print/:artifact",
  "/oireachtas/stripe",
  "/oireachtas/draw",
  "/oireachtas/draws",
  "/oireachtas/check-in",
  "/oireachtas/tabulation",
  "/oireachtas/results",
  "/oireachtas/reporting",
  "/oireachtas/organizer-view",
  "/oireachtas/schedule",
  "/default-syllabi",
  "/payment-requests",
  "/feis/create",
  "/oireachtas/create",
  "/grade/create",
  "/previous-events",
  "/grade/create/finalGradeDetails",
  "/feis/create/finalFeisDetails",
  "/oireachtas/create/finalOireachtasDetails",
  "/competitorss/:name",
  "/candidate/:name",
  "/edit-candidates/:name",
  "/grade/edit-register/:name",
  "/edit-competitors/:name",
  "/stripe-account",
  "/organizer-account",
  "/edit-register/:name",
  "/merge-split/:name",
  "/merge-split-comp/:name",
  "/email",
  "/check-in/:name" ,
  "/result-status/:name",
  "/tabulate/:name",
  "/complete-results/:name",
  "/score-checkin-download/:name",
  "/now-next-signs/:name",
  "/transaction-history/:name" ,
  "/published-results/:name", 
  "/awards",
  "/dancers",
  "/dancers/details/:id",
  "/parents/details/:id"
];
